/* eslint-disable @typescript-eslint/no-explicit-any */
import Vue from "vue";
import VueRouter, { RouteConfig, Route } from "vue-router";
import Home from "../views/Home.vue";
import WorkMate from "../views/WorkMate.vue";

// "global" variables from config file(s)
// copied to Vue prototype to make them available for all views
import Config from "../utils/Config";
const config = new Config();
Object.keys(config.globals).forEach((global: string) => {
  Vue.prototype[global] = config.globals[global];
});

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/(callback)?",
    name: "Home",
    component: Home,
    meta: {
      title: "WorkMate",
      icon: require("@/static/favicon-64x64.png")
    }
  },
  {
    path: "/hazard-list",
    name: "WorkMate",
    component: WorkMate,
    meta: {
      title: "WorkMate",
      icon: require("@/static/favicon-64x64.png")
    }
  },
  {
    path: "*",
    beforeEnter: (to: Route, from: Route, next: CallableFunction) => {
      next(from);
    }
  }
];

const router = new VueRouter({
  mode: "history",
  routes
});

router.beforeEach((to: Route, from: Route, next: any) => {
  document.title = (to.meta as any).title;
  const link: HTMLElement | null = document.querySelector("[rel='icon']");
  (link as HTMLElement).setAttribute("href", (to.meta as any).icon);
  next();
});
export default router;
